// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9d8f14c8","389":"67c171a5","453":"25a8f554","732":"0dd65013","977":"b6e22d7a"}[chunkId] + ".chunk.js";
};